import { render, staticRenderFns } from "./DetalleGrupo.vue?vue&type=template&id=07bda618&scoped=true"
import script from "./DetalleGrupo.vue?vue&type=script&lang=js"
export * from "./DetalleGrupo.vue?vue&type=script&lang=js"
import style0 from "./DetalleGrupo.vue?vue&type=style&index=0&id=07bda618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bda618",
  null
  
)

export default component.exports